import React from 'react';
import classnames from 'classnames';
import styles from './index.module.css';

class Button extends React.Component {
  render() {
    return (
      <button className={classnames(styles['button'], this.props.small && styles['button-small'], this.props.className)}
              onClick={this.props.onClick}>
        {this.props.children}
      </button>
    )
  };
}

export default Button;
